/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_WarrantyInputs */

const en_doc_type_warranty = /** @type {(inputs: Doc_Type_WarrantyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warranty Document`)
};

const id_doc_type_warranty = /** @type {(inputs: Doc_Type_WarrantyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen Garansi`)
};

/** @type {(inputs: Doc_Type_WarrantyInputs) => LocalizedString} */
const es_doc_type_warranty = en_doc_type_warranty;

/** @type {(inputs: Doc_Type_WarrantyInputs) => LocalizedString} */
const fr_doc_type_warranty = en_doc_type_warranty;

/** @type {(inputs: Doc_Type_WarrantyInputs) => LocalizedString} */
const de_doc_type_warranty = en_doc_type_warranty;

/** @type {(inputs: Doc_Type_WarrantyInputs) => LocalizedString} */
const ja_doc_type_warranty = en_doc_type_warranty;

/** @type {(inputs: Doc_Type_WarrantyInputs) => LocalizedString} */
const zh_doc_type_warranty = en_doc_type_warranty;

/** @type {(inputs: Doc_Type_WarrantyInputs) => LocalizedString} */
const ar_doc_type_warranty = en_doc_type_warranty;

/** @type {(inputs: Doc_Type_WarrantyInputs) => LocalizedString} */
const it_doc_type_warranty = en_doc_type_warranty;

/** @type {(inputs: Doc_Type_WarrantyInputs) => LocalizedString} */
const ru_doc_type_warranty = en_doc_type_warranty;

/** @type {(inputs: Doc_Type_WarrantyInputs) => LocalizedString} */
const pt_doc_type_warranty = en_doc_type_warranty;

/** @type {(inputs: Doc_Type_WarrantyInputs) => LocalizedString} */
const ko_doc_type_warranty = en_doc_type_warranty;

/**
* | output |
* | --- |
* | "Warranty Document" |
*
* @param {Doc_Type_WarrantyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_warranty = /** @type {((inputs?: Doc_Type_WarrantyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_WarrantyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_warranty(inputs)
	if (locale === "es") return es_doc_type_warranty(inputs)
	if (locale === "fr") return fr_doc_type_warranty(inputs)
	if (locale === "de") return de_doc_type_warranty(inputs)
	if (locale === "ja") return ja_doc_type_warranty(inputs)
	if (locale === "zh") return zh_doc_type_warranty(inputs)
	if (locale === "ar") return ar_doc_type_warranty(inputs)
	if (locale === "id") return id_doc_type_warranty(inputs)
	if (locale === "it") return it_doc_type_warranty(inputs)
	if (locale === "ru") return ru_doc_type_warranty(inputs)
	if (locale === "pt") return pt_doc_type_warranty(inputs)
	return ko_doc_type_warranty(inputs)
});